import React from "react";
import { CompatibilityRing } from "@/components/CompatibilityRing";
import { Check, AlertTriangle } from "lucide-react";

const CAT_LABELS = { lifestyle: "Lifestyle", living_habits: "Living habits", practical: "Practical", work: "Work routine", personal: "Age & fit" };

export function CompatibilityBreakdown({ compatibility, name }) {
  if (!compatibility) return null;
  const { score, matches = [], discuss = [], categories = {} } = compatibility;
  return (
    <div className="rounded-3xl bg-white p-5 shadow-card" data-testid="compatibility-breakdown">
      <div className="flex items-center gap-4">
        <CompatibilityRing score={score} size={72} stroke={6} />
        <div>
          <h3 className="font-heading text-2xl font-extrabold text-ink">{score}% compatible</h3>
          <p className="text-sm text-ink-soft">You & {name || "them"} — based on your shared preferences</p>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3">
        {Object.entries(categories).map(([k, v]) => (
          <div key={k} className="rounded-2xl bg-secondary p-3">
            <div className="flex items-center justify-between">
              <span className="text-xs font-semibold text-ink-soft">{CAT_LABELS[k] || k}</span>
              <span className="font-heading text-sm font-bold text-ink">{v}%</span>
            </div>
            <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-white">
              <div className="h-full rounded-full" style={{ width: `${v}%`, backgroundColor: v >= 70 ? "#10B981" : v >= 45 ? "#F59E0B" : "#9CA3AF" }} />
            </div>
          </div>
        ))}
      </div>

      {matches.length > 0 && (
        <div className="mt-5">
          <p className="mb-2 text-sm font-bold text-ink">You both match well on</p>
          <div className="space-y-1.5">
            {matches.map((m) => <p key={m} className="flex items-center gap-2 text-sm text-ink-soft"><span className="grid h-5 w-5 place-items-center rounded-full bg-mint/15"><Check className="h-3 w-3 text-mint" /></span> {m}</p>)}
          </div>
        </div>
      )}

      {discuss.length > 0 && (
        <div className="mt-4">
          <p className="mb-2 text-sm font-bold text-ink">Things to discuss</p>
          <div className="space-y-1.5">
            {discuss.map((m) => <p key={m} className="flex items-center gap-2 text-sm text-ink-soft"><span className="grid h-5 w-5 place-items-center rounded-full bg-sunset/15"><AlertTriangle className="h-3 w-3 text-sunset" /></span> {m}</p>)}
          </div>
        </div>
      )}
    </div>
  );
}
